import { Box, List, Typography } from "@mui/material";
import React from "react";

import { CommunicationRow } from "./CommunicationRow";
import ContactListItem from "./components/ContactListItem";
import { CustomerCommunication } from "../../../store/services/communicationService";

interface GroupedCommunicationsProps {
  communications: CustomerCommunication[];
  customerNo: number;
  addGroupEdit?: boolean;
}

export const GroupedCommunications = ({
  communications,
  customerNo,
  addGroupEdit = false,
}: GroupedCommunicationsProps) => {
  const groupedCommunications = React.useMemo(() => {
    const groups: Record<string, CustomerCommunication[]> = {
      general: [],
    };

    communications.forEach((comm) => {
      if (comm.ContactPerson) {
        const key = `person_${comm.ContactPersonNo}`;
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(comm);
      } else {
        groups.general.push(comm);
      }
    });

    return groups;
  }, [communications]);

  return (
    <List>
      {addGroupEdit && groupedCommunications.general.length > 0 ? (
        <Box
          sx={{
            backgroundColor: (theme) => theme.palette.grey[200],
          }}
        >
          <Typography variant="h6">Ospecificerad Kommunikation</Typography>
          {groupedCommunications.general.map((comm) => (
            <CommunicationRow
              key={comm.CommunicationNo}
              communication={comm}
              customerNo={customerNo}
            />
          ))}
        </Box>
      ) : (
        groupedCommunications.general.map((comm) => (
          <CommunicationRow
            key={comm.CommunicationNo}
            communication={comm}
            customerNo={customerNo}
          />
        ))
      )}
      {Object.entries(groupedCommunications)
        .filter(([key]) => key !== "general")
        .map(([key, comms]) => {
          const contactPerson = {
            ...comms[0].ContactPerson!,
            Communications: comms,
          };

          return (
            <Box key={key}>
              <ContactListItem
                contactPerson={contactPerson}
                customerNo={customerNo}
                addGroupEdit={addGroupEdit}
              />

              <Box>
                {comms.map((comm) => (
                  <CommunicationRow
                    key={comm.CommunicationNo}
                    communication={comm}
                    customerNo={customerNo}
                  />
                ))}
              </Box>
            </Box>
          );
        })}
    </List>
  );
};

export default GroupedCommunications;
